import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { OpenAPI } from '@pro-sto/api-client';
import { StoreProvider } from '@/stores/StoreContext';
import App from './App';

// Global styles from shared UI package
import '@pro-sto/ui/styles/variables.css';
import '@pro-sto/ui/styles/reset.css';
import '@pro-sto/ui/styles/global.css';

// Configure API client — empty string means relative URL (same origin, nginx proxies /api)
OpenAPI.BASE = import.meta.env.VITE_API_BASE_URL ?? '';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <StoreProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StoreProvider>
  </StrictMode>,
);
